<template>
  <div>
    <BannerImg
      bannerPosition="DXAL_BANNER"
      :title="titleData.title"
      :subTitle="titleData.subTitle"
    />

    <div class="case-container" style="margin-top: 0px">
      <div class="case-head">
        <el-row class="w-full flex justify-center">
          <el-col
            :xs="8"
            :md="3"
            :lg="2"
            v-for="(item, index) of listMap.keys()"
            :key="index"
            style="padding: 10px 20px; cursor: pointer; text-align: center"
            :class="{ active: active == item }"
          >
            <span class="case-head-title" @click="handlePositionClock(item)">{{
              item
            }}</span>
          </el-col>
        </el-row>
      </div>
      <div class="case-contant">
        <div>
          <div :id="`id${index}`"></div>
          <main
            justify="center"
            style="gap: 40px"
            class="flex flex-wrap align-middle space-between"
          >
            <section
              :xs="24"
              :md="12"
              :lg="12"
              v-for="(child, index) in listMap.get(active).filter((item) => {
                return item.caseCover != null && item.caseCover != '';
              })"
              style="margin-bottom: 15px; max-width: 632px"
              class="p0"
            >
              <EiiCard
                :info="{
                  id: child.id,
                  img: child.caseCover,
                  title: child.caseTitle,
                  subTitle: child.caseContent,
                  caseClass: child.caseClass,
                }"
                :handle-details-click="handleDetailsClick"
                :key="child"
                style="
                  display: flex;
                  width: 400px;
                  height: 260px;
                  margin-top: 20px;
                  justify-content: center;
                  align-items: center;
                  position: relative;
                "
              >
                <div
                  class="cardinfo"
                  style="
                    position: absolute;
                    bottom: 0px;
                    display: flex;
                    width: 400px;
                    height: 55px;
                    line-height: 10px;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                  "
                >
                  {{ child.caseTitle }}
                </div>
              </EiiCard>
            </section>
          </main>
        </div>
      </div>

      <el-pagination
        :page-size="page.pageSize"
        :current-page="page.pageNum"
        style="margin-top: 60px; margin-bottom: 100px"
        background
        layout="prev, pager, next"
        :total="page.total"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>
  
  <script>
import { listBanner, queryPageTypicalCase } from "@/api";
import EiiCard from "@/components/EiiCard.vue";
import BannerImg from "@/components/BannerImg.vue";

export default {
  name: "TypicalCase",
  components: { BannerImg, EiiCard },
  data() {
    return {
      // 返回顶部按钮
      showButton: false,
      active: null,
      listMap: [],
      titleData: {},
      sourceType: "img",
      bannerImg: "",
      video: "",
      bannerPath: "",
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10000,
      },
    };
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getList();
    // 获取banner数据
    this.getBanner();
  },
  methods: {
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {
      this.showButton = window.scrollY > 200;
    },
    async getBanner() {
      const res = await listBanner({
        bannerPosition: "DXAL_BANNER",
        useFlag: "1",
      });

      const data = res.rows.find(
        (v) =>
          (v.bannerImg && v.sourceType == "img") ||
          (v.video && v.sourceType == "video")
      );
      if (!data) return;
      this.sourceType = data.sourceType;
      this.bannerImg = data.bannerImg;
      this.video = data.video;
      this.bannerPath = data.link;
    },
    async getList() {
      const params = {
        pageNum: 1,
        pageSize: 100000,
      };
      const res = await queryPageTypicalCase(params);

      const listMap = res.rows;
      if (listMap && listMap[0]) {
        this.active = listMap[0].caseClassName;
      }
      // prettier-ignore
      // 根据 caseClassName 分组 , 生成Map listMap
      const map = new Map()
      for (const item of listMap) {
        if (map.has(item.caseClassName)) {
          map.get(item.caseClassName).push(item);
        } else {
          map.set(item.caseClassName, [item]);
        }
      }
      this.listMap = map;
      console.log(this.listMap);
      this.page.total = res.total;
    },
    changePage(val) {
      this.page.pageNum = val;
      this.getList();
    },

    handlePositionClock(item) {
      this.active = item;
      // this.$el.querySelector(`#id${index}`).scrollIntoView({
      //   behavior: 'smooth',  // 平滑过渡
      //   block: 'start'
      // })
    },

    handleDetailsClick(item) {
      this.$router.push({
        path: "/solition_lower",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.el-col-md-3:first-of-type {
  width: 11% !important;
}
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
.el-col-md-3:first-of-type {
  width: 11%;
}
.el-card.is-hover-shadow:hover {
  box-shadow: 15px 18px 25px 0px rgba(0, 0, 0, 0.3);
}
.case-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  margin-bottom: 200px;
  margin: 0 auto;
  width: 1280px;

  .cardinfo {
    display: flex;
    width: 400px;
    height: 72px;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    color: #fff;
    background: #00000063;
  }

  .case-head {
    width: 100%;
    margin-top: 60px;

    .case-head-title {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      font-size: 16px;
    }

    .active {
      color: var(--color-primary, #e10009);
      // border-bottom: 2px solid var(--color-primary, #D7000F);
    }
  }

  .case-contant {
    // max-width: 1248px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/anli.vue